import { t } from "../../i18n";
import { useEffect, useState } from "react";
import type { ShareDto } from "@tasduvar/shared";
import { api, errorMessage } from "../../api/client";
import { useProjectStore } from "../../state/projectStore";
import { Button } from "../../ui/Button";
import { Dialog } from "../../ui/Dialog";
import { Toggle } from "../../ui/Toggle";

/** Bağlantı istemcide üretilir: uygulama alt yolda (/tasduvar/) yayınlanıyorsa da doğru olsun. */
const shareUrl = (token: string): string => new URL(`${import.meta.env.BASE_URL}paylasim/${token}`, window.location.origin).href;

export function ShareDialog({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element | null {
  const project = useProjectStore((s) => s.project);
  const [items, setItems] = useState<ShareDto[]>([]);
  const [allowDownload, setAllowDownload] = useState(true);
  const [days, setDays] = useState<number | null>(30);
  const [err, setErr] = useState<string>(); const [copied, setCopied] = useState<string>();
  const load = (): void => { if (project) void api<ShareDto[]>("GET", `/projects/${project.id}/shares`).then((xs) => setItems(xs.map((x) => ({ ...x, url: shareUrl(x.token) })))).catch((e: unknown) => setErr(errorMessage(e))); };
  useEffect(() => { if (open) load(); }, [open, project?.id]);
  if (!open || !project) return null;
  const create = async (): Promise<void> => {
    try {
      const expiresAt = days ? new Date(Date.now() + days * 86_400_000).toISOString() : undefined;
      const s = await api<ShareDto>("POST", `/projects/${project.id}/shares`, { allowDownload, expiresAt });
      setItems([{ ...s, url: shareUrl(s.token) }, ...items]); void copy(shareUrl(s.token));
    } catch (e) { setErr(errorMessage(e)); }
  };
  const copy = async (url: string): Promise<void> => { try { await navigator.clipboard.writeText(url); setCopied(url); } catch { setCopied(undefined); } };
  const revoke = async (token: string): Promise<void> => { await api("DELETE", `/shares/${token}`); setItems(items.filter((i) => i.token !== token)); };
  return (
    <Dialog open onClose={onClose} label={t("Paylaş")} width={520} footer={<Button variant="ghost" onClick={onClose}>{t("Kapat")}</Button>}>
      <h2>{t("Paylaşım bağlantısı")}</h2>
      <p className="text-[11px] text-cad-ink3">{t("Bağlantıyı alan herkes projeyi oturum açmadan salt okunur görür. İstediğiniz zaman iptal edebilirsiniz.")}</p>
      <Toggle id="sh-dl" label={t("Rapor indirmeye izin ver (PDF/Word/DXF/JSON)")} checked={allowDownload} onChange={setAllowDownload} />
      <div className="flex items-center gap-2"><label htmlFor="sh-days" className="text-[11px] text-cad-ink2">{t("Geçerlilik")}</label>
        <select id="sh-days" className="cad-input font-sans" value={days ?? 0} onChange={(e) => setDays(Number(e.target.value) || null)}><option value={7}>{t("7 gün")}</option><option value={30}>{t("30 gün")}</option><option value={90}>{t("90 gün")}</option><option value={0}>{t("Süresiz")}</option></select>
        <Button onClick={() => void create()}>{t("Bağlantı oluştur")}</Button></div>
      {err ? <p role="alert" className="text-xs text-bad">{err}</p> : null}
      {items.length > 0 ? (
        <ul className="max-h-60 overflow-auto border border-cad-soft2" aria-label={t("Aktif bağlantılar")}>
          {items.map((s) => (
            <li key={s.token} className="px-1.5 py-1 text-[11px] grid gap-1 border-b border-cad-soft2 last:border-b-0">
              <div className="flex items-center gap-1.5"><input readOnly className="cad-input flex-1 font-mono !text-[11px]" value={s.url} aria-label={t("Paylaşım adresi")} onFocus={(e) => e.target.select()} /><Button variant="ghost" onClick={() => void copy(s.url)}>{copied === s.url ? t("Kopyalandı") : t("Kopyala")}</Button><Button variant="danger" onClick={() => void revoke(s.token)}>{t("İptal")}</Button></div>
              <div className="text-cad-ink3">{s.allowDownload ? t("indirme açık") : t("yalnız görüntüleme")} · {s.expiresAt ? `${new Date(s.expiresAt).toLocaleDateString("tr-TR")} tarihine kadar` : t("süresiz")}</div>
            </li>
          ))}
        </ul>
      ) : null}
    </Dialog>
  );
}
